var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54912 0.418663C9.10734 -0.139555 10.0124 -0.139554 10.5706 0.418665L11.5813 1.42941C12.1396 1.98763 12.1396 2.89267 11.5813 3.45089L10.2993 4.73291L7.26709 1.70069L8.54912 0.418663Z",
    fill: "#ADB2BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25635 2.71143L9.28858 5.74365L4.05239 10.9798C3.85775 11.1745 3.61107 11.3088 3.34196 11.3666L0.432664 11.9918C0.179062 12.0463 -0.0462892 11.8209 0.00820872 11.5673L0.633405 8.65804C0.691234 8.38893 0.825532 8.14225 1.02016 7.94762L6.25635 2.71143Z",
    fill: "#ADB2BA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3b7085d31e8f7dc7848a0861507d90c0.svg";
export { ForwardRef as ReactComponent };